



































































































































import {
  Component,
  Prop,
  Vue, Watch,
} from 'vue-property-decorator';
import EventBus from '@/services/eventbus.service';
import JobsService from '@/services/jobs.service';
import {Getter, Mutation, Action} from 'vuex-class';

@Component
export default class JobMenu extends Vue {
  @Prop() private openMenu!: boolean;
  @Mutation private clearJobs: any;
  @Mutation private removeCompletedJobs: any;
  @Mutation private addActiveJob: any;
  @Mutation private addCompletedJob: any;
  @Mutation private cancelJob: any;
  @Getter private activeAccountId!: any;
  @Getter private activeJobs: any;
  @Getter private hasPermission: any;
  @Getter private completedJobs: any;
  @Getter private activeOrganisationId: any;

  private poller: any = null;
  private moveUp: number = -46;

  @Watch('activeOrganisationId')
  private onOrgChange(newVal: number, oldVal: number) {
    if (newVal === oldVal) {
      return;
    }
    this.clearJobs();
  }

  @Watch('openMenu')
  private onMenuOpen() {
    if (this.openMenu) {
      if (this.poller) {
        clearInterval(this.poller);
      }
      this.poller = setInterval(this.pollActiveJobs.bind(this), 1000);
    } else {
      clearInterval(this.poller);
      this.poller = null;
      this.moveUp = -46;
    }
  }

  private mounted() {
    (window as any).EventBus = EventBus;
    EventBus.$on('jobCreated', this.startJobNotification);
    EventBus.$on('adminJobCreated', this.startAdminJobNotification);
    EventBus.$on('accountJobCreated', this.startAccountJobNotification);
  }

  private beforeDestroy() {
    EventBus.$off('jobCreated', this.startJobNotification);
    EventBus.$off('adminJobCreated', this.startAdminJobNotification);
    EventBus.$off('accountJobCreated', this.startAccountJobNotification);
  }

  private async startJobNotification(id: string) {
    const job = await JobsService.pollJob(id);
    const newJob = {jobId: id, pollData: job, jobContext: 'user'};
    this.addActiveJob(newJob);
    if (this.activeJobs.length > 1) {
      this.moveUp += 66;
    }
    this.getCurrentJobValue(newJob);
    this.$emit('open');
  }

  private async startAccountJobNotification(id: string) {
    const job = await JobsService.pollAccountJob(this.activeAccountId, id);
    const newJob = {jobId: id, pollData: job, jobContext: 'account'};
    this.addActiveJob(newJob);
    if (this.activeJobs.length > 1) {
      this.moveUp += 66;
    }
    this.getCurrentJobValue(newJob);
    this.$emit('open');
  }

  private async startAdminJobNotification(id: string, admin: boolean = false) {
    const job = await JobsService.pollAdminJob(id);
    const newJob = {jobId: id, pollData: job, jobContext: 'admin'};
    this.addActiveJob(newJob);
    if (this.activeJobs.length > 1) {
      this.moveUp += 66;
    }
    this.getCurrentJobValue(newJob);
    this.$emit('open');
  }

  private pollActiveJobs(): void {
    if (!this.activeJobs.length) {
      return;
    }

    this.activeJobs.forEach(async (job: any) => {
      try {
        let polledJobData: any;

        switch (job.jobContext) {
          case 'account':
            if (!this.activeAccountId) { return; }
            polledJobData = await JobsService.pollAccountJob(this.activeAccountId, job.jobId);
            break;
          case 'admin':
            polledJobData = await JobsService.pollAdminJob(job.jobId);
            break;
          case 'user':
          default:
            polledJobData = await JobsService.pollJob(job.jobId);
            break;
        }

        const currJob = {...job, pollData: polledJobData};
        this.getCurrentJobValue(currJob);

        job.pollData = polledJobData;

        if (polledJobData.status === 'completed' || polledJobData.status === 'failed' || polledJobData.status === 'completed with warnings' ) {
          this.addCompletedJob(currJob);

          if (polledJobData.type.startsWith('device')) {
            if (this.hasPermission('device:read')) {
              EventBus.$emit('DevicesTable:LoadDevices');
            } else if (this.hasPermission('inventory:read')) {
              EventBus.$emit('InventoryDevicesTable:LoadDevices');
            }
          }

          if (polledJobData.type.startsWith('gateways')) {
            if (this.hasPermission('gateway:read')) {
              EventBus.$emit('GatewaysTable:LoadGateways');
            } else if (this.hasPermission('inventory:read')) {
              EventBus.$emit('InventoryGatewaysTable:LoadGateways');
            }
          }
          if (polledJobData.type.startsWith('location')) {
            EventBus.$emit('ProjectComposer:RefreshLocation');
          }
          if (polledJobData.type.startsWith('subscriptions') && job.jobContext === 'account') {
            EventBus.$emit('AccountSubscriptionsTable:LoadSubscriptions');
          }
        }
      } catch (e) {
        this.cancelJob(job.jobId);
      }
    });
  }

  // TODO: Component needs refactoring to be more universal
  private getCurrentJobValue(job: any) {
    let percentageComplete = 0;
    const isExport = job.pollData.type.split('_').includes('export');
    if (!isExport && Object.keys(job.pollData.data).length > 0) {
      const processed = job.pollData.data.skipped + job.pollData.data.imported;
      percentageComplete = processed / job.pollData.data.rows * 100;
    } else if (job.pollData.type === 'location_export') {
      percentageComplete = 75;
    }
    for (const j of this.activeJobs) {
      if (j.jobId === job.jobId) {
        Vue.set(j, 'percentageComplete', percentageComplete);
      }
    }
  }

  private getStatusColor(status: string) {
    switch (status) {
      case 'completed': return 'green--text';
      case 'completed with warnings': return 'amber--text';
      case 'failed': return 'red--text';
    }
  }

  private hasViewableErrors(job: any): boolean {
    return !!(job.pollData.data && job.pollData.data.errors && job.pollData.data.errors.length);
  }

  private openJobDetail(job: any) {
    this.$emit('click:history', job.pollData.id);
  }

}
